import { useState } from 'react';
import { Row, Col, Form, Button, Alert, Accordion } from 'react-bootstrap';
import { createUser } from '../../../services/adminService';

const CreateUser = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        familyName: '',
        dateOfBirth: '',
        email: '',
        gender: '0',
        postcode: '',
        post_town: '',
        county: '',
        postal_county: '',
        line_1: '',
        line_2: '',
        line_3: '',
        district: '',
        password: '',
        //userClaimsRoles: []
    });

    //const userClaimsRolesList = [
    //    { label: "Admin", value: "Admin" },
    //    { label: "Service Lead", value: "Service Lead" },
    //    { label: "Chat", value: "Chat" },
    //    { label: "NRT Approval", value: "NRT Approval" },
    //    { label: "NRT Deliveries", value: "NRT Deliveries" },
    //    { label: "Reporting", value: "Reporting" }
    //];

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Convert the gender value to a number
        if (name === 'gender') {
            setFormData({ ...formData, [name]: Number(value) });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };


    //const handleRoleChange = (e) => {
    //    const { value, checked } = e.target;
    //    setFormData((prevData) => ({
    //        ...prevData,
    //        userClaimsRoles: checked
    //            ? [...prevData.userClaimsRoles, value]
    //            : prevData.userClaimsRoles.filter(role => role !== value)
    //    }));
    //};

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const result = await createUser(formData);

            if (result) {
                setSuccessMessage('User created successfully!');
                setFormData({
                    firstName: '',
                    familyName: '',
                    dateOfBirth: '',
                    email: '',
                    gender: '0',
                    postcode: '',
                    post_town: '',
                    county: '',
                    postal_county: '',
                    line_1: '',
                    line_2: '',
                    line_3: '',
                    district: '',
                    password: ''
                    //userClaimsRoles: []
                });
            }
        } catch (error) {
            setErrorMessage('Failed to create user. Please try again.');
            console.error(error);
        }
    };

    return (
        <div className="component createNewUser">
            <Accordion defaultActiveKey={null}> {/* Ensures it's collapsed by default */}
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <Row>
                            <Col>
                                <h3>Create New User</h3>
                            </Col>
                        </Row>
                    </Accordion.Header>
                    <Accordion.Body>
                        <Row>
                            <Col xs={12}>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="firstName" className="mb-3">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="familyName" className="mb-3">
                                        <Form.Label>Family Name</Form.Label>
                                        <Form.Control type="text" name="familyName" value={formData.familyName} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="email" className="mb-3">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="password" className="mb-3">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" name="password" value={formData.password} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="gender" className="mb-3">
                                        <Form.Label>Gender</Form.Label>
                                        <Form.Select name="gender" value={formData.gender} onChange={handleChange}>
                                            <option value="0">Woman</option>
                                            <option value="1">Man</option>
                                            <option value="2">Other</option>
                                            <option value="3">NonBinary</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group controlId="dateOfBirth" className="mb-3">
                                        <Form.Label>Date of Birth</Form.Label>
                                        <Form.Control type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="postcode" className="mb-3">
                                        <Form.Label>Postcode</Form.Label>
                                        <Form.Control type="text" name="postcode" value={formData.postcode} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="post_town" className="mb-3">
                                        <Form.Label>Post Town</Form.Label>
                                        <Form.Control type="text" name="post_town" value={formData.post_town} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="county" className="mb-3">
                                        <Form.Label>County</Form.Label>
                                        <Form.Control type="text" name="county" value={formData.county} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="postal_county" className="mb-3">
                                        <Form.Label>Postal County</Form.Label>
                                        <Form.Control type="text" name="postal_county" value={formData.postal_county} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="line_1" className="mb-3">
                                        <Form.Label>Address Line 1</Form.Label>
                                        <Form.Control type="text" name="line_1" value={formData.line_1} onChange={handleChange} required />
                                    </Form.Group>

                                    <Form.Group controlId="line_2" className="mb-3">
                                        <Form.Label>Address Line 2</Form.Label>
                                        <Form.Control type="text" name="line_2" value={formData.line_2} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group controlId="line_3" className="mb-3">
                                        <Form.Label>Address Line 3</Form.Label>
                                        <Form.Control type="text" name="line_3" value={formData.line_3} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group controlId="district" className="mb-3">
                                        <Form.Label>District</Form.Label>
                                        <Form.Control type="text" name="district" value={formData.district} onChange={handleChange} required />
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className="mb-3">
                                        Create User
                                    </Button>
                                </Form>

                                {successMessage && <Alert variant="success">{successMessage}</Alert>}
                                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}


                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            
        </div>
    );
};

export default CreateUser;
